import { Box } from '@mui/material';
import { PoolLineClampTypography } from '@synergy/components-next';
import { ReactElement } from 'react';
import { useSearchParams } from 'react-router-dom';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

import { SupplierListItemBoxLinks } from './supplier-list-item-box-links';
import { SupplierListItemBoxProps } from './supplier-list-item-box-props';

export const SupplierListItemBoxContent = (props: SupplierListItemBoxProps): ReactElement => {
    const [searchParams] = useSearchParams();

    const search = searchParams.get('search') ?? '';
    const nameMatches = match(props.item.name, search);
    const nameParts = parse(props.item.name, nameMatches);

    return (
        <>
            <PoolLineClampTypography maxLines={1}>
                <strong>
                    {nameParts.map((namePart, index) => (
                        <Box key={index} component="span" color={namePart.highlight ? 'primary.main' : undefined}>
                            {namePart.text}
                        </Box>
                    ))}
                </strong>
            </PoolLineClampTypography>
            <PoolLineClampTypography maxLines={1}>
                <Box>{props.item.address.fullAddress}</Box>
            </PoolLineClampTypography>
            <SupplierListItemBoxLinks item={props.item} />
        </>
    );
};
